<template>
  <div class="home">
    <h1> PUBG 一键作图</h1>
    <div class="tips">免费无隐患</div>
    <div class="search-box">
      <div></div>
      <input
          type="text"
          class="search-input"
          placeholder="请输入您要估值的steam账号17位ID"
          v-model="steam"
      />
      <button class="search-btn" @click="preview">确定</button>
    </div>
    <div style="margin-top: 10px;">
      <a target="_blank" href="https://ldds.com/article/item?id=49" class="how">
        如何获取steam账号的17位ID？
      </a>
    </div>

    <div class="create" v-show="showCreate">
      <div class="bg-box">
        <div
            class="btn-item"
            :class="{ disable: pageIndex <= 1 }"
            style="margin-right: 20px"
            @click="
                        () =>
                            (pageIndex =
                                pageIndex <= 1 ? pageIndex : pageIndex - 1)
                    "
        >
          上一页
        </div>
        <img
            v-for="(item, index) of bgList"
            :key="index"
            :src="item"
            @click="() => (bg = `url(${item})`)"
        />
        <div
            class="btn-item"
            :class="{ disable: pageIndex >= 5 }"
            style="margin-left: 20px"
            @click="
                        () =>
                            (pageIndex =
                                pageIndex >= 5 ? pageIndex : pageIndex + 1)
                    "
        >
          下一页
        </div>
      </div>
      <div class="create-l">
        <div class="btn-item">
          <colorPicker v-model="color"></colorPicker>
        </div>
        <div class="btn-item">
          上传背景图
          <input
              type="file"
              @change="uploadImg($event)"
              class="uploadimg"
          />
        </div>
        <div class="btn-item" @click="() => (showTags? showTags= false:showTags=true)">
          {{ showTags ? '隐藏等级' : '显示等级' }}
        </div>
        <div class="btn-item" @click="() => (showCow= 8)">
          显示8列
        </div>
        <div class="btn-item" @click="() => (showCow= 10)">
          显示10列
        </div>
        <div class="btn-item" @click="() => (showCow= 12)">
         显示12列
        </div>
        <div class="btn-item" @click="createLine">
          增加一行
        </div>
        <div class="btn-item" @click="suitshow">
          套装分类
        </div>
        <div class="btn-item" @click="() => (sendVal = true)">
          添加描述
        </div>
        <div
            class="btn-item"
            v-if="iconIsFinish && !showloading && !showCreateLoading"
            @click="creatImg()"
        >
          生成图片
        </div>
        <div v-else-if="showCreateLoading" class="btn-item disable">
          图片生成中
          <div class="loader-01"></div>
        </div>
        <div class="btn-item disable" v-else>
          资源加载中
          <div class="loader-01"></div>
        </div>
      </div>

      <div class="zt-box">
        <div class="zt-left " :class="{fixed:fixed}">
          <div class="assert_box" v-if="selected">
            <div class="close" @click="close">X</div>
            <div class="img-box">
              <div style="font-size: 24px" v-if="selected.level>0"><span>LV{{ selected.level }}</span></div>
              <div style="border-radius: 10px;">
                <img alt="" :src="selected.icon_url" style="max-width: 200px;width: 100%">
              </div>
            </div>
            <div class="selected-item" v-if="selected.zh_name">
              {{ selected.zh_name }}
            </div>
            <div class="selected-item">
              {{ selected.name }}
            </div>
            <div class="selected-item" v-if="selected.level>0">
              <div class="selected-tag">等级：</div>
              <div class="selected-desc">
                <select v-model="selected.level" style="width: 100px" class="select"
                        @change="changeLevel(selected,$event)">
                  <option v-for="i in 10" :value="i" :key="i">{{ '等级' + i }}</option>
                </select>
              </div>
            </div>
            <div class="selected-item">
              <div class="selected-tag">数量：</div>
              <div class="selected-desc">
                <input v-model="selected.num" style="width: 100px" class="select"/>
              </div>
            </div>
            <div class="selected-item">
              <div class="selected-tag">描述：</div>
              <div class="selected-desc">
                {{ selected.marketable == 1 ? "Steam市场可出售" : "Steam市场不可出售" }}
              </div>
            </div>
            <div class="selected-item">
              <div class="btn-item btn-primary" @click="remove">删除</div>
              <div class="btn-item btn-success" @click="top" v-if="selected.is_top>0">置顶</div>
            </div>
          </div>
        </div>

        <div
            ref="capture"
            class="create-r"
            :style="bodyStyle">

          <div class="kpw">
                    <span class="scdj-text">
                        可 排 位
                    </span>
          </div>
          <div class="scdj" v-if="showScdj">
            <span class="scdj-text">
              生存等级500级
            </span>
          </div>
          <div v-if="pubgList.length > 0" class="pubg" :class="{preview2:showCow===12,preview10:showCow===10}">
            <img v-for="img in pubgList" :key="img" :src="img" class="txz-image"/>
          </div>
          <div style="height: 40px;"></div>
          <div class="valuation-seal" v-if="false" :class="'grade'+grade">
            <div class="valuation-close" @click="()=>(finishPrice=false)">X</div>
            <div class="seal">
              <d class="seal-son">
                <div style="font-size: 110px;color: #fff;transform: rotate(353deg);">{{ price }}</div>
              </d>
            </div>
          </div>
          <div class="text-content">
            <div v-if="false">
              可在Steam市场出售的库存价值：{{ valuation }}元
            </div>
            <div v-if="descVal">{{ descVal }}</div>
          </div>
          <div style="height: 60px;"></div>
          <div class="newline-box" v-for="(newDrive,index) in newDriveList" :key="index">
            <div class="tools-box" v-if="showtools">
              <div class="top" @click="topLine(index,newDriveList)"><img src="../assets/top.png"></div>
              <div class="delete" @click="deleteLine(index,newDriveList)"><img src="../assets/delete.png"></div>
              <div class="bottom" @click="downLine(index,newDriveList)"><img src="../assets/bottom.png"></div>
            </div>
            <div class="centent-box">
              <draggable v-model="newDrive.list" class="new-line" group="image">
                <transition-group class="preview" :class="{preview2:showCow===12,preview10:showCow===10}">
                  <div
                      v-for="(item,index) in newDrive.list"
                      :key="index"
                      class="item-box"
                      @click="changeImage(item,newDrive.list)"
                  >
                    <div class="imgblock">
                      <img
                          @load="computeLoadImgLen"
                          @error="errLoad(index - 1)"
                          :src="item.icon_url"
                          :alt="item.name"
                      />
                      <div class="level" v-if="item.level>0&&showTags">
                      <span class="level-text">
                         Lv{{ item.level }}
                      </span>
                      </div>
                      <span class="price" v-if="item.currency>0&&showPrice">{{ item.currency }}</span>
                      <div class="num" v-if="item.num>1">
                        <span class="num-text">
                        x{{ item.num }}
                        </span>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
          <div class="suit-box" v-for="(suitDrive,index) in suitDriveList" :key="index">
            <div class="tools-box" v-if="showtools">
              <div class="top" @click="topLine(index,suitDriveList)"><img src="../assets/top.png"></div>
              <div class="delete" @click="deleteLine(index,suitDriveList)"><img src="../assets/delete.png"></div>
              <div class="bottom" @click="downLine(index,suitDriveList)"><img src="../assets/bottom.png"></div>
            </div>
            <div class="centent-box">
              <draggable v-model="suitDrive.list" class="new-line" group="image">
                <transition-group class="preview" :class="{preview2:showCow===12,preview10:showCow===10}">
                  <div
                      v-for="(item,index) in suitDrive.list"
                      :key="index"
                      class="item-box"
                      @click="changeImage(item,suitDrive.list)"
                  >
                    <div class="imgblock">
                      <img
                          @load="computeLoadImgLen"
                          @error="errLoad(index - 1)"
                          :src="item.icon_url"
                          :alt="item.name"
                      />
                      <div class="level" v-if="item.level>0&&showTags">
                      <span class="level-text">
                         Lv{{ item.level }}
                      </span>
                      </div>
                      <span class="price" v-if="item.currency>0&&showPrice">{{ item.currency }}</span>
                      <div class="num" v-if="item.num>1">
                        <span class="num-text">
                        x{{ item.num }}
                        </span>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
          <draggable v-model="bigDriveList" style="z-index: 1;" group="image">
            <transition-group class="preview" :class="{preview2:showCow===12,preview10:showCow===10}">
              <div
                  v-for="(item,index) in bigDriveList"
                  :key="index"
                  class="item-box"
                  @click="changeImage(item,bigDriveList)"
              >
                <div class="imgblock">
                  <img
                      @load="computeLoadImgLen"
                      @error="errLoad(index - 1)"
                      :src="item.icon_url"
                      :alt="item.name"
                  />
                  <div class="level" v-if="item.level>0&&showTags">
                    <span class="level-text">
                       Lv{{ item.level }}
                    </span>
                  </div>
                  <span class="price" v-if="item.currency>0&&showPrice">{{ item.currency }}</span>
                  <div class="num" v-if="item.num>1">
                        <span class="num-text">
                        x{{ item.num }}
                        </span>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div style="height: 80px;"></div>
          <draggable v-model="smallDriveList" style="z-index: 1;" group="image" v-if="smallDriveList">
            <transition-group class="little-icons">
              <div
                  v-for="(item,index) in  smallDriveList"
                  :key="index"
                  class="img-box"
              >
                <img
                    @load="computeLoadImgLen"
                    @error="errLoad(index + canDriveCount - 1)"
                    :src="item.icon_url"
                    :alt="item.name"
                />
              </div>
            </transition-group>
          </draggable>
          <div style="height: 40px;"></div>

        </div>
        <div class="back-top" v-if="fixed&&showtools" @click="scrollTop">
          <img src="../assets/scrollTop.png"/>
          返回顶部
        </div>
        <div class="zt-right" :class="{fixed:fixed}">
          <div class="btn-item" style="width: 100%;border-radius: 5px 5px 0 0 "> 素材区
          </div>
          <div>
            <div class="right-box">
              <draggable v-model="materialList" :scroll="true" group="image" class="right-box-icons">
                <transition-group style="display: flex;flex-wrap: wrap;  align-content: flex-start;">
                  <div
                      v-for="(item,index) in  materialList"
                      :key="index"
                      class="img-box"
                  >
                    <img
                        :src="item.icon_url"
                        :alt="item.name"
                    />
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-show" v-show="showloading">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>请稍后</div>
    </div>
    <div class="result">
      <img :src="img" alt="" srcset=""/>
    </div>

    <ul class="show-img">
      <li><img src="../assets/index-1.png"/></li>
      <li><img src="../assets/index-2.png"/></li>
      <li><img src="../assets/index-3.png"/></li>
    </ul>
    <dialog-bar
        v-model="sendVal"
        type="confirm"
        title="添加编号、描述文字"
        @confirm="clickConfirm()"
        confirmText="确定"
    >
      <input class="desc-input" v-model="descVal" type="text"/>
    </dialog-bar>
    <el-dialog
        :visible.sync="finishPrice"
        custom-class="notbackground"
        center>
      <transition name="el-zoom-in-center">
        <div class="valuation-seal" v-if="finishPrice" :class="'grade'+grade">
          <div class="seal">
            <d class="seal-son">
              <div style="font-size: 110px;color: #fff;transform: rotate(353deg);text-shadow: 2px 2px 5px #FF5722;">
                {{ price }}
              </div>
            </d>
          </div>
        </div>
      </transition>
    </el-dialog>
  </div>

</template>

<script>
import html2canvas from "html2canvas";
import {
  CreateImage,
  GetImageList,
  GetMaterial,
  GetSuitshowList,
  GetValuationLogList,
  SaveLevel,
  SaveValuationLog
} from "../server";
import draggable from "vuedraggable";
import {Hosts} from "../unitl/config";
import DialogBar from "../components/dialog.vue";
import {Falert, getStorageSync} from "../unitl/common";
import {constant} from "../unitl/constant";

var browser = {
  versions: (function () {
    var u = navigator.userAgent;
    return {
      //移动终端浏览器版本信息
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf("MicroMessenger") > -1, //是否微信
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
export default {
  name: "Home",
  data() {
    return {
      showCreateLoading: false,
      showTags: true,
      showCow: false,
      showPrice: true,
      pubgList: [],
      sendVal: false,
      editLevel: false,
      editName: false,
      selected: "",
      selectedMoel: "",
      descVal: "",
      steam: "",
      collection_id: "",//抓取记录id
      img: "",
      show_name: 1,
      showloading: false,
      showCreate: false,
      color: "#000",
      cdn_url: "",
      newDriveList: [],//可以
      suitDriveList: [],//套装
      bigDriveList: [],//可以
      smallDriveList: [],
      tmpStoreList: [],
      materialList: [],
      valuationLogList: [],
      valuationLogCount: 0,
      tmpTagIndex: 1,
      List: [],
      bgList: [],
      bgStyle: 0,
      imgLen: 0,
      file: "",
      pageIndex: 1,
      valuation: 0,
      iconIsFinish: false,
      bg: "",
      bg2: '',
      baseUrl: Hosts.host,
      showShuiyin: false,
      images: [],
      canDriveCount: 500,
      txz_list: {},
      showScdj: false,
      fixed: false,
      showtools: true,
      valuationBox: true,
      price: "",
      finishPrice: false,
      grade: 0
    };
  },
  computed: {
    bodyStyle() {
      var backgroundImg = '';
      var backgroundRepeat = '';
      var bg = require('../assets/bg3.png');

      if (this.showShuiyin) {
        backgroundImg = `url(${bg})`;
        backgroundRepeat = 'repeat-y';
      }
      if (this.bg) {
        if (backgroundImg != '') {
          backgroundImg = backgroundImg + ',' + this.bg;
          backgroundRepeat = backgroundRepeat + ',' + (this.bgStyle ? 'repeat-y' : 'no-repeat');
        } else {
          backgroundImg = this.bg;
          backgroundRepeat = (this.bgStyle ? 'repeat-y' : 'no-repeat');
        }
      }
      let style = {
        backgroundImage: backgroundImg,
        backgroundRepeat: backgroundRepeat,
        backgroundSize: '100%',
        backgroundColor: this.color
      }
      return style;
    }
  },
  components: {
    draggable,
    DialogBar
    // FileUpload,
  },
  watch: {
    pageIndex(val) {
      this.loadBackgounds(val);
    }
  },
  methods: {
    clickConfirm() {
      console.log("点击了confirm");
    },
    changeLevel(selected, event) {
      selected.level = event.target.value
      SaveLevel(this.steam, selected.classid, selected.level)
    },
    changeBackground(selected, event) {
      selected.precious = event.target.value
    },
    changeGrade(grade, event) {
      grade = event.target.value
    },
    changeBgStyle() {
      return (this.bgStyle = !this.bgStyle ? 1 : 0);
    },
    submit() {
      if (this.showloading) {
        return;
      }
      this.showloading = true;
      CreateImage(this.steam)
          .then(data => {
            this.img = `data:image/jpeg;base64,${data.image}`;
            this.showloading = false;
          })
          .catch(() => {
            this.showloading = false;
          });
    },
    preview() {
      if (this.showloading) {
        return;
      }
      this.List = [];
      this.suitDriveList = [];
      this.materialList=[];
      this.showCreate = false;
      this.showloading = true;
      this.img = "";
      this.price = ""
      this.finishPrice = false;
      this.showtools = true
      this.grade = 0
      GetImageList(this.steam)
          .then(data => {
            this.showScdj = false;
            this.txz_list = data.txz_list;
            this.collection_id = data.collection_id;
            data.inventory_list.sort(function (x, y) {
              var sort = x['precious'] - y['precious'];
              var sort2 = x['level'] - y['level'];
              var sort3 = x['valuation'] - y['valuation'];
              if (sort > 0) {
                return -1;
              } else if (sort == 0) {
                if (sort2 > 0) {
                  return -1;
                } else if (sort2 == 0) {
                  if (sort3 > 0) {
                    return -1;
                  } else {
                    return 0;
                  }
                } else {
                  return 1;
                }
              } else {
                return 1;
              }
            })
            this.images = data.inventory_list;
            this.loadBase64Img(data);

            var userInfo = JSON.parse(getStorageSync(constant.userInfo) || '{}');
            if (userInfo && userInfo.shuiyin) {
              this.showShuiyin = false;
            }
          })
          .catch(() => {
            this.showloading = false;
          });
      this.material();
    },
    errLoad(idx) {
      console.log('imageError', this.images[idx].name, this.images[idx].icon_url);
      this.computeLoadImgLen();
    },
    computeLoadImgLen() {
      this.imgLen += 1;
      if (this.imgLen === this.List.length) {
        this.iconIsFinish = true;
      }
    },
    getRandom(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
    },
    loadBase64Img(data) {
      this.showloading = false;
      this.showCreate = true;
      this.imgLen = 0;
      this.pubgList = [];
      this.List = data.inventory_list.map(element => {
        if (element.name == "BETTER LUCK NEXT TIME") {
          console.log(element);
          this.showScdj = true;
        }
        if (this.txz_list && this.txz_list[element.name]) {
          this.pubgList.push(this.txz_list[element.name].icon_url);
        }
        if (element['valuation'] > 10) {
          // console.log(element['name'],element['sort'],element['valuation'])
        }
        this.valuation += element.valuation || 0;
        element.icon_url = "http://steam-images.weilaiwangluo.com/economy/image/" + element.icon_url;
        return element;
      });
      this.bigDriveList = this.List.slice(0, this.canDriveCount - 1)
      this.smallDriveList = this.List.slice(this.canDriveCount - 1)
    },
    uploadImg(ev) {
      const self = this;
      const file = ev.target;
      const reader = new FileReader();
      reader.readAsDataURL(file.files[0]);
      reader.onloadend = function (e) {
        self.bg = `url(${e.target.result})`;
        self.file = e.target.result;
      };
    },
    creatImg() {
      this.selected = "";
      this.showtools = false
      this.$nextTick(() => {
        this.showloading = true;
        this.showCreate = false;
        this.showCreateLoading = true;
        let scale =1;
        let rect = this.$refs.capture.getBoundingClientRect();
        const rate = 4000 / rect.height;
        if (
            rate < 1 &&
            (browser.versions.mobile ||
                browser.versions.ios ||
                browser.versions.android ||
                browser.versions.iPhone ||
                browser.versions.iPad)
        ) {
          scale=2;
        }

        const scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        html2canvas(this.$refs.capture, {
          imageTimeout: 1000000,
          scale:scale,
          useCORS: true,
          scrollX:-scrollX,
          scrollY: -scrollTop,
          width: rect.width ,
          height: rect.height
        }).then(canvas => {
          // 通过a标签下载到本地
          let link = document.createElement("a");
          link.href = canvas.toDataURL("image/jpeg");
          link.setAttribute("download", Date.now() + ".jpg");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          this.showCreate = true;
          this.showCreateLoading = false;
          this.showloading = false;
          this.showtools = true
        });
      })
    },
    loadBackgounds(val) {
      this.bgList = [];
      for (let i = val * 10 - 9; i <= val * 10; i++) {
        this.bgList.push(require(`../assets/bg/list${i}.jpeg`));
        this.$forceUpdate();
      }
    },
    changeImage(val, model) {
      this.selected = val;
      this.selectedMoel = model;
      if (model != this.bigDriveList) {
        this.selected.is_top = false
      }

    },
    top() {
      this.bigDriveList.map((item, index) => {
        if (item == this.selected) {
          this.bigDriveList.unshift(this.bigDriveList.splice(index, 1)[0]);
        }
      })
    },
    remove() {
      this.selectedMoel.map((item, index) => {
        if (item == this.selected) {
          this.selectedMoel.splice(index, 1)[0];
          this.selected = ''
        }
      })
    },
    close() {
      this.selected = ''
    },
    reset() {
      this.price = ""
      this.grade = ""
    },
    confirm() {
      if (this.price == "") {
        Falert('价格未填');
        return;
      }
      this.finishPrice = true
      SaveValuationLog(this.steam, this.price, this.grade)
      GetValuationLogList(this.steam)
          .then(data => {
            this.valuationLogCount = data.list.count;
            this.valuationLogList = data.list.list;
          })
          .catch(() => {
          });
    },
    clearTmp() {
      this.tmpStoreList.map((item, index) => {
        this.bigDriveList.unshift(this.tmpStoreList.splice(index, 1)[0]);
      })
      this.tmpStoreList = [];
    },
    scrollTop() {
      window.scrollTo(100, 500);
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 700) {
        this.fixed = true
      } else {
        this.fixed = false
      }
    },
    createLine() {
      this.newDriveList.push({'title': '新的一行', list: []})
    },
    deleteLine(index, model) {
      model[index].list.map((item, idx) => {
        this.bigDriveList.unshift(model[index].list.splice(idx, 1)[0]);
      })
      model.splice(index, 1)
    },
    topLine(index, model) {
      if (index === 0) {
        Falert('已经是最顶部了');
        return;
      }
      model[index] = model.splice(index - 1, 1, model[index])[0];
    },
    downLine(index, model) {
      if (index === model.length - 1) {
        Falert('已经是最底部了');
        return;
      }
      model[index] = model.splice(index + 1, 1, model[index])[0];

    },
    suitshow() {
      GetSuitshowList(this.steam)
          .then(data => {
            this.suitDriveList = data.inventory_list;
              this.suitDriveList.forEach(itemB => {
                itemB.list.forEach((itemC) => {
                  let indexA = this.bigDriveList.findIndex(itemD => itemD.classid == itemC.classid)
                  if (indexA!==false) {
                    this.bigDriveList.splice(indexA, 1)
                  }
                  let indexB = this.smallDriveList.findIndex(itemD => itemD.classid == itemC.classid)
                  if (indexB!==false) {
                    this.smallDriveList.splice(indexB, 1)
                  }
                })
            })
          })
          .catch(() => {
          });
    },
    material() {
      this.tmpTagIndex = 2;
      if (this.materialList.length == 0) {
        this.tmpTagIndex = 2;
        GetMaterial().then(data => {
          this.materialList = data.list.list;
        })
      }
    }
  },
  mounted() {
    this.loadBackgounds(this.pageIndex);
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  }
};
</script>
<style>
.btn-item .m-colorPicker {
  width: 100%;
  height: 100%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.btn-item .m-colorPicker::before {
  content: "选择背景颜色";
  padding-right: 7px;
}

#app {
  overflow: visible !important;
}

.notbackground {
  background: none !important;
}

.el-dialog__close {
  font-size: 36px !important;
}
</style>
<style scoped>
.fixed {
  position: fixed !important;
  top: 50px !important;
}

.fixed1 {
  position: fixed !important;
  top: 470px !important;
}

.selected-item {
  display: flex;
  padding: 5px 30px;
  justify-content: center;
}

.selected-item .mobile, .selected-item .valuation, .selected-item .time {
  padding: 5px 5px 5px 0;
  font-size: 12px;
  word-break: break-all;
}

.time {
  width: 75px;
}

.item-left {
  width: 80px;
  text-align: left;
}

.selected-item input {
  background: #fff;
  width: 100%;
}

.zt-box {
  width: 100%;
  position: relative;
}

.staging_top_btn {
  display: flex;
}

.zt-left {
  color: #fff;
  position: absolute;
  left: 20px;
  top: 0;
  max-width: 270px;
  width: 14%;
  min-width: 100px;
  background: hsla(0, 0%, 100%, .12);
  z-index: 999;
}

.zt-right-bottom {
  background: hsla(0, 0%, 100%, .12);
  color: #fff;
  z-index: 888;
  position: absolute;
  max-width: 270px;
  width: 14%;
  right: 1%;
  top: 5%;
}

.close {
  display: flex;
  justify-content: right;
  padding-right: 10px;
  font-size: 22px;
}

.assert_box {
  border-radius: 20px;
  padding-bottom: 20px;
}

.zt-right {
  position: absolute;
  right: 1%;
  top: 0;
  max-width: 270px;
  min-width: 200px;
  width: 14%;
  border-radius: 5px;
  z-index: 100;
}

.zt-left .img-box {
  padding: 5px 30px;

}

.input-box::-webkit-scrollbar {
  width: 0;
}

.right-box {
  margin-top: 20px;
  background: hsla(0, 0%, 100%, .12);
  border-radius: 0 0 5px 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.right-box .img-box {
  width: 50px;
  height: 50px;
  padding: 5px;

}

.right-box .img-box img {
  background: hsla(0, 0%, 100%, .12);
  border-radius: 5px;
  width: 50px;
}

.right-box-icons {
  height: 300px;
  max-width: 260px;
  width: 100%;
  display: flex;
  overflow-y: auto;
  justify-content: center;
  flex-wrap: wrap;
}

.right-box-icons::-webkit-scrollbar {
  width: 0;
}

.radio {
  color: #ffffff;
  text-align: left;
}

.radio > input[type="radio"] {
  margin-left: 20px;
}

.kpw {
  width: 280px;
  height: 75px;
  top: 35px;
  right: -68px;
  position: absolute;
  transform: rotate(45deg);
  z-index: 111;
}

.level {
  width: 70px;
  height: 20px;
  top: 5px;
  right: -20px;
  position: absolute;
  transform: rotate(45deg);
  z-index: 111;
}

.level-text {
  line-height: 20px;
  position: absolute;
  bottom: 0;
  display: block;
  font-size: 14px;
  color: #F0F0F0;
  width: 70px;
  text-align: center;
  height: 20px;
  background-color: #449eff;
  font-weight: bold;
}

.scdj {
  width: 280px;
  height: 75px;
  top: 35px;
  left: -68px;
  position: absolute;
  transform: rotate(-45deg);
  z-index: 11111
}

.scdj-text {
  line-height: 40px;
  position: absolute;
  bottom: 0;
  display: block;
  font-size: 24px;
  color: #F0F0F0;
  width: 280px;
  text-align: center;
  height: 40px;
  background-color: #449eff;
  font-weight: bold;
}

h1 {
  margin-top: 140px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
}

.tips {
  padding-left: 20px;
  margin: 19px auto 0;
  width: 70px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(65, 194, 131, 1);
  line-height: 28px;
  background: url("../assets/green.png") left center no-repeat;
}

.search-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.search-input {
  width: 510px;
  height: 46px;
  background: rgba(198, 212, 223, 1);
  border: none;
  outline: none;
  text-indent: 20px;
}

.search-input::placeholder {
  color: #869199;
}

.search-btn {
  width: 120px;
  height: 46px;
  background: rgba(44, 82, 129, 1);
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}

.btns {
  display: flex;
}

.bg-box {
  display: flex;
  height: 100px;
  margin-bottom: 30px;
  align-items: center;
  justify-content: center;
}

.bg-box img {
  height: 100%;
  cursor: pointer;
}

.how {
  padding-top: 26px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  text-decoration: underline;
  color: rgba(110, 173, 223, 1);
  line-height: 17px;
}

.show-img {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 235px;
  margin-bottom: 102px;
  overflow: hidden;
}

.show-img > li {
  margin-left: 20px;
}

.tag {
  z-index: 99;
  width: 45px;
  height: 26px;
  position: absolute;
  background: url('../images/level.png');
  background-size: 100%;
  color: #fff;
  right: 0;
  padding-right: 5px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
}

.tag img {
  width: 30px;
  height: 20px;
}

.result {
  margin-top: 20px;
}

.loading-show {
  margin-top: 30px;
  color: #ffffff;
}
.pubg{
  padding: 0 156px;
}
.loader-01 {
  border: 0.2em dotted currentcolor;
  border-radius: 50%;
  -webkit-animation: 1s loader-01 linear infinite;
  animation: 1s loader-01 linear infinite;
  font-size: 14px;
  display: inline-block;
  width: 8px;
  height: 8px;
  color: inherit;
  vertical-align: middle;
  pointer-events: none;
  margin-left: 4px;
}

.create {
  display: flex;
  margin: 0 auto;
  padding-top: 100px;
  width: 100%;
  flex-direction: column;
}

.create-l {
  padding-bottom: 24px;
  top: 0px;
  position: sticky;
  z-index: 1000;
  display: flex;
  justify-content: center;
}

.txz-image {
  width: 250px;
  //height: 130px;
}
.preview2 .txz-image {
  width: 150px;
  //height: 130px;
}
.preview10 .txz-image {
  width: 150px;
  //height: 130px;
}
.btn-item {
  color: #fff;
  height: 38px;
  border-radius: 4px;
  display: flex;
  width: 130px;
  align-items: center;
  justify-content: center;
  background: rgba(44, 82, 129, 1);
  position: relative;
  float: left;
  margin-right: 10px;
  cursor: pointer;
}

.btn-item.disable {
  background: #83b5e8;
}

.bg-2 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  background-color: rgba(0, 0, 0, 0);
  background-repeat: repeat-y;
  background-size: 100%;
}

.create-r {
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: left top;
  margin: 0 auto;
  max-width: 1140px;
  border: 1px solid #ddd;
  overflow: hidden;
  position: relative;
  top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.create-r .text-content {
  color: red;
  font-size: 24px;
}

.create-r .text-content div {
  font-size: 24px;
}

.little-icons {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.little-icons .img-box {
  width: 61px;
  height: 61px;
  background: #3a3a3a;
  margin-bottom: 2px;
  padding: 4px;
}

.little-icons img {
  width: 100%;
  height: 100%;
}

.create-l > h3 {
  color: #ffffff;
  text-align: left;
  font-size: 16px;
  margin: 15px 0;
}

.desc-input {
  border: 1px solid #d7d7d7;
  height: 36px;
  width: 324px;
  padding: 0 10px;
  font-size: 15px;
  border-radius: 4px;
  margin-top: 30px;
}

.imgblock {
  cursor: move;
  overflow: hidden;
  max-width: 125px;
  max-height: 155px;
  min-height: 121px;
  position: relative;
  border-radius: 10px;
}

.preview2 .imgblock {
  cursor: move;
  overflow: hidden;
  max-width: 80px;
  max-height: 155px;
  min-height: auto;
  position: relative;
  border-radius: 10px;
}
.preview2 .imgblock .num-text,.preview2 .imgblock .num{
  height: 16px;
  line-height: 16px;
}
.preview2 .imgblock .num{
  right: -25px;
}
.preview10 .imgblock {
  cursor: move;
  overflow: hidden;
  max-width: 98px;
  max-height: 155px;
  min-height: auto;
  position: relative;
  border-radius: 10px;
}
.preview10 .imgblock .num-text,.preview10 .imgblock .num{
  height: 16px;
  line-height: 16px;
}
.preview10 .imgblock .num{
  right: -25px;
}
.imgblock:hover {
  box-shadow: 0px 0px 5px #2a3d50;
}

.imgblock > img {
  width: 100%;
}

.flip-list-move {
  transition: transform 1s;
}

.preview {
  display: flex;
  flex-wrap: wrap;
  width: 1080px;
}

.create-btn {
  margin-top: 30px;
  width: 150px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  background: rgba(44, 82, 129, 1);
  color: #ffffff;
  font-size: 16px;
}

.uploadimg {
  background-color: #ffffff;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.back-top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  position: fixed;
  right: 18%;
  z-index: 1000;
  top: 200px
}

.desc {
  color: #f00;
  display: flex;
  justify-content: right;
  padding: 5px;
}

.num {
  position: absolute;
  right: -20px;
  bottom: 5px;
  width: 70px;
  height: 20px;
  transform: rotate(310deg);
  z-index: 111;
}
.num-text {
  line-height: 20px;
  position: absolute;
  bottom: 0;
  display: block;
  font-size: 14px;
  color: #F0F0F0;
  width: 70px;
  text-align: center;
  height: 20px;
  background-color: #449eff;
  font-weight: bold;
}
.item-box {
  position: relative;
  padding: 5px;
}

.input {
  padding: 10px;
  font-size: 22px;
  background-color: transparent !important;
  color: #fff !important;
  text-align: center;
  border: 0 solid hsla(0, 0%, 100%, .24) !important
}

.input:focus {
  border: 1px solid hsla(0, 0%, 100%, .24) !important
}

.precious9 {
  background: linear-gradient(to right bottom, #ef8c8c, #ffe01a 200px);
}

.precious8 {
  background: linear-gradient(to right bottom, #5c0072, #df7af8 200px);
}

.precious7 {
  background: linear-gradient(to right bottom, #5c0072, #1980e7 200px);
}

.grade9 {
  background-color: #ffe01aeb !important;
}

.grade8 {
  background-color: #df7af8eb !important;
}

.grade7 {
  background-color: #1980e7eb !important;
}

.grade0 {
  /*background-color: #1b1e21eb !important;*/
}

.newline-box, .suit-box {
  min-height: 80px;
  //border-bottom: 2px solid #1b1e21;
  display: flex;
}

.newline-box .tools-box, .suit-box .tools-box {
  display: flex;
  width: 30px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

}
.newline-box .tools-box, .suit-box .tools-box .delete{
  height: 30px;
}
.newline-box .tools-box, .suit-box .tools-box .top{
  height: 30px;
}
.newline-box .tools-box, .suit-box .tools-box .bottom{
  height: 30px;
}
.newline-box .tools-box, .suit-box .tools-box img{
  height: 30px;
}
.centent-title {
  color: #fff;
  font-size: 22px;
}

.newline-box .centent-box, .suit-box .centent-box {
  justify-content: center;
  align-items: center;
}

.new-line {
  min-height: 80px;
  justify-content: center;
}

.new-line .preview {
  justify-content: center;
}

.valuation-seal {
  position: fixed;
  z-index: 10000;
  border-radius: 100%;
  top: 12%;
  background: url("../images/seal.png");
  background-size: cover;
}

.seal {
  width: 800px;
  height: 800px;
  border-radius: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seal-son {
  width: 800px;
  height: 800px;
  border: solid 2rpx #B4B4B4;
  border-radius: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.valuation-close {
  position: absolute;
  right: 120px;
  top: 90px;
  font-size: 60px;
  color: #fff;
  z-index: 20000;
}
</style>
